/**
 * Browser environment utilities.
 *
 * These are also defined as inline globals in templates/components/scripts/nav-and-parse-utils.html
 * so they are available before the webpack bundle loads. The inline versions are the
 * authoritative runtime source; these exports exist for webpack module consumers.
 */

export function getNavigationType() {
    // Modern API — available in all current browsers.
    const navEntry = performance.getEntriesByType('navigation')[0];
    if (navEntry) return navEntry.type; // 'navigate' | 'reload' | 'back_forward' | 'prerender'
    // Fallback to deprecated PerformanceNavigation for older browsers.
    const legacyType = performance.navigation?.type;
    if (legacyType !== undefined) {
        return ({ 0: 'navigate', 1: 'reload', 2: 'back_forward' })[legacyType] || 'navigate';
    }
    return 'navigate';
}

export function getDeviceType() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'tablet';
    }
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return 'mobile';
    }
    return 'desktop';
}
